var $7097f64386f1761c$exports = {};
$7097f64386f1761c$exports = {
  "alpha": "Alfa",
  "black": "sort",
  "blue": "Bl\xE5",
  "blue purple": "bl\xE5lilla",
  "brightness": "Lysstyrke",
  "brown": "brun",
  "brown yellow": "brungul",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "cyan",
  "cyan blue": "cyan bl\xE5",
  "dark": "m\xF8rk",
  "gray": "gr\xE5",
  "grayish": "gr\xE5lig",
  "green": "Gr\xF8n",
  "green cyan": "gr\xF8n cyan",
  "hue": "Tone",
  "light": "lys",
  "lightness": "Lyshed",
  "magenta": "magenta",
  "magenta pink": "magenta pink",
  "orange": "orange",
  "orange yellow": "orangegul",
  "pale": "bleg",
  "pink": "lyser\xF8d",
  "pink red": "lyser\xF8dlig r\xF8d",
  "purple": "lilla",
  "purple magenta": "lilla magenta",
  "red": "R\xF8d",
  "red orange": "r\xF8dorange",
  "saturation": "Farvem\xE6tning",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " gennemsigtig");
  },
  "very dark": "meget m\xF8rk",
  "very light": "meget lys",
  "vibrant": "klar",
  "white": "hvid",
  "yellow": "gul",
  "yellow green": "gulgr\xF8n"
};
export { $7097f64386f1761c$exports as default };